import React from 'react';
import CodeBlockV2 from '../../CodeBlockV2';

interface Props {
  product: string;
  oauth?: boolean;
}

// Helper function to generate quickstart code for a given language
const generateQuickstartCode = (
  directory: string,
  setup: string,
  oauth: boolean,
): string => {
  const oauthEnvMessage = `# Copy the .env.example file to .env, then fill
# out PLAID_CLIENT_ID, PLAID_SECRET,
# PLAID_COUNTRY_CODES=GB, and
# PLAID_REDIRECT_URI=http://localhost:3000/`;

  const defaultEnvMessage = `# Copy the .env.example file to .env, then fill
# out PLAID_CLIENT_ID and PLAID_SECRET in .env`;

  if (directory === 'curl') {
    return `# not applicable for curl, pick a different language from the dropdown`;
  }

  return `# Note: If on Windows, run
# git clone -c core.symlinks=true https://github.com/plaid/quickstart
# instead to ensure correct symlink behavior

git clone https://github.com/plaid/quickstart.git

cd quickstart/${directory}

${oauth ? oauthEnvMessage : defaultEnvMessage}
cp .env.example .env

${setup}

# Start the backend app
./start.sh`;
};

const RunQuickstart: React.FC<Props> = (props) => {
  const variants = {
    node: generateQuickstartCode(
      'node',
      `# Install dependencies
npm install`,
      props.oauth || false,
    ),
    bash: generateQuickstartCode(
      'curl',
      `# Install dependencies
npm install`,
      props.oauth || false,
    ),
    ruby: generateQuickstartCode(
      'ruby',
      `# Install dependencies
bundle`,
      props.oauth || false,
    ),
    python: generateQuickstartCode(
      'python',
      `# Note: must use python 3

# For virtualenv users:
# virtualenv venv
# source venv/bin/activate
pip3 install -r requirements.txt`,
      props.oauth || false,
    ),
    java: generateQuickstartCode(
      'java',
      'mvn clean package',
      props.oauth || false,
    ),
    go: generateQuickstartCode('go', 'go build', props.oauth || false),
  };

  return (
    <CodeBlockV2
      type='server'
      variants={variants}
      title='1. Clone the Quickstart and run the backend'
    />
  );
};

RunQuickstart.displayName = 'RunQuickstart';
export default RunQuickstart;
